<template>
  <v-container fluid>
    <v-card flat>
      <v-toolbar>
        <v-icon color="red">highlight_off</v-icon>
        <v-toolbar-title class="font-weight-light">
          <v-row>
            <v-col>
              <div>&nbsp;Anulación de Movimiento</div>
            </v-col>
          </v-row>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="hide(false)"><v-icon>close</v-icon></v-btn>
      </v-toolbar>

      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col cols="3" class="caption"> Caja </v-col>
            <v-col>
              {{ caja.descripcion }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" class="caption"> Fecha </v-col>
            <v-col>
              {{ this.$moment(caja.abiertaEl).format('DD-MM-YYYY') }}
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="3" class="caption"> Concepto </v-col>
            <v-col>
              {{ concepto }}
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="3" class="caption"> Importe </v-col>
            <v-col>
              {{ importe | currency }}
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="3" class="caption"> Info </v-col>
            <v-col>
              {{ info }}
            </v-col>
          </v-row>

          <v-row>
            <v-textarea
              v-model="comentarios"
              class="mx-2"
              label="Por qué motivo se anula el movimiento?"
              prepend-icon="comment"
              clearable
              auto-grow
            ></v-textarea>
          </v-row>

          <v-row
            justify="end"
            v-if="!checkCanAccess('ap-anulacion-movimiento-caja')"
          >
            <v-spacer></v-spacer>
            <app-autorizador
              v-bind:EstaAutorizado.sync="autorizadoPorExcepcion"
              v-bind:MotivoAutoriza.sync="autorizadoPorMotivo"
              v-bind:UsuarioAutoriza.sync="autorizadoPorUsuario"
            >
            </app-autorizador>
            <template>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">info</v-icon>
                </template>
                Esta operación requiere autorización de un encargado.
              </v-tooltip>
            </template>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-btn
              color="blue darken-1"
              text
              @click.stop="hide(false)"
              :disabled="saving"
              >Cerrar</v-btn
            >
            <v-spacer></v-spacer>

            <v-btn
              color="blue darken-1"
              text
              @click.stop="save()"
              :disabled="saving || !anulacionAutorizada"
              >Confirmar Anulación</v-btn
            >
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>

    <app-loading :loading="saving"></app-loading>

    <template v-if="$store.state.debugModeOn">
      Debug Info:
      <p></p>
    </template>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { http } from '@/axios';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  data: () => ({
    saving: false,
    comentarios: '',
    autorizadoPorExcepcion: false,
    autorizadoPorUsuario: '',
    autorizadoPorMotivo: '',
  }),
  props: {
    caja: { type: Object, default: {} },
    transaccionId: { type: String },
    concepto: { type: String },
    info: { type: String },
    importe: { type: Number },
    accionCompleta: { type: Function },
    isSubTask: { type: Boolean, default: false },
    visible: { type: Boolean, default: false },
  },
  async created() {},
  computed: {
    ...mapGetters(['getActionFromLink', 'user', 'checkCanAccess']),
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
    anulacionAutorizada() {
      return (
        this.checkCanAccess('ap-anulacion-movimiento-caja') ||
        this.autorizadoPorExcepcion
      );
    },
  },
  watch: {
    visible: function () {},
  },
  methods: {
    ...mapMutations([
      'setActiveTask',
      'setActiveSubTask',
      'hideActiveTask',
      'hideActiveSubTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
      'setReporteActivo',
    ]),
    async save() {
      if (!this.validarDatos()) return;

      var params = {
        cajaId: this.caja.id,
        transaccionId: this.transaccionId,
        motivo:
          this.comentarios +
          (this.autorizadoPorExcepcion
            ? 'Autorizado por ' + this.autorizadoPorUsuario
            : ''),
        user: this.user.login,
      };

      this.saving = true;
      try {
        await http.put(
          'businesscore/anulartransaccion',
          JSON.stringify(params)
        );
        //await this.alertSuccess('La Transacción ha sido anulada');
        await this.hide(true);
        this.generarParte();
        this.emitAccionCompleta();
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.saving = false;
    },
    async generarParte() {
      let params = [];

      params.push({
        TransaccionId: this.transaccionId,
      });

      this.setReporteActivo({
        reporte: 'Parte de Anulacion.trdp',
        params: params,
      });
      window.open('/report-viewer');
    },
    validarDatos() {
      if (!this.comentarios) {
        this.alertWarning('Por favor, ingrese el motivo de la anulación.');
        return false;
      }

      if (
        !this.checkCanAccess('ap-anulacion-movimiento-caja') &&
        !this.autorizadoPorExcepcion
      ) {
        this.alertWarning(
          'No tiene el permiso necesario para realizar esta acción. Debe pedir a un encargado que lo autorice.'
        );
        return false;
      }

      return true;
    },
    hide(cerrarRelacionados) {
      //esto lo hago para que no se buguee cuando lo abro como subtask o task
      if (this.isSubTask) this.hideActiveSubTask();
      else this.hideActiveTask(cerrarRelacionados);
    },
    emitAccionCompleta() {
      if (this.accionCompleta) this.accionCompleta();

      this.$emit('accion-completa');
    },
  },
};
</script>
